import Button from '@carvana/ds-button';
import { Trash2 } from 'lucide-react';
import { useContext } from 'react';
import StaticContext from '~/context/common/StaticContext';
import { clearFeatureCookies } from '~/utilities/featureBranch';

export default function ClearButton() {
  const { clientId, kubernetesAppName } = useContext(StaticContext);

  const handleClear = clearFeatureCookies(kubernetesAppName, clientId);

  return (
    <Button
      className="pointer-events-auto mr-20 h-28 self-end t-label-xs"
      onClick={handleClear}
      data-analytics-id="Clear feature branch"
      data-testid="clear-feature-branch"
      title="Clear feature branch"
      size="sm"
      variant="destructive"
      utility
    >
      <Trash2 size={12} /> Clear Branch
    </Button>
  );
}
